var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMars = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4H20V8L18.7071 6.73712L17.0056 8.43864C18.2433 9.77626 19 11.5653 19 13.53C19 17.67 15.64 21.03 11.5 21.03C7.36 21.03 4 17.67 4 13.53C4 9.39 7.36 6.03 11.5 6.03C12.9521 6.03 14.3082 6.44336 15.4571 7.15874L17.2929 5.32291L16 4ZM11.5 8.03C14.53 8.03 17 10.5 17 13.53C17 16.56 14.53 19.03 11.5 19.03C8.47 19.03 6 16.56 6 13.53C6 10.5 8.47 8.03 11.5 8.03Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMars);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mars.aae543d29b4bdd4da2533dfc80433c71.svg";